import React from 'react';
import {
    SidebarContainer,
    Icon,
    CloseIcon,
    SidebarWrapper,
    SidebarLink,
    SidebarRoute,
    SideBtnWrap,
    SidebarMenu
} from './SidebarElements'

const Sidebar = ({isOpen, toggle}) => {
    return (
        <SidebarContainer isOpen={isOpen} onClick={toggle}>
            <Icon onClick={toggle}>
                <CloseIcon />
            </Icon>
            <SidebarWrapper>
                <SidebarMenu>
                    <SidebarLink to='about' onClick={toggle}>
                        Über Uns
                    </SidebarLink>
                    <SidebarLink to='discover' onClick={toggle}>
                        Ziele
                    </SidebarLink>
                    <SidebarLink to='services' onClick={toggle}>
                        Vorteile
                    </SidebarLink>
                    <SidebarLink to='profits' onClick={toggle}>
                        Warum Uns
                    </SidebarLink>
                    <SidebarLink to='signup' onClick={toggle}>
                        Download
                    </SidebarLink>
                </SidebarMenu>
                <SideBtnWrap>
                    <SidebarRoute to='/impressium'>Starte als Creator</SidebarRoute>
                </SideBtnWrap>
            </SidebarWrapper>
        </SidebarContainer>
    )
}

export default Sidebar